import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { Button } from '../../../../Basic/Button';
import VoucherModal from './VoucherModal';

var RedeemVoucher = function RedeemVoucher(_ref) {
  var refreshCallback = _ref.refreshCallback,
      translate = _ref.translate;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var onToggle = function onToggle() {
    setIsOpen(function (isOpen) {
      return !isOpen;
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    btype: "important",
    onClick: function onClick() {
      return setIsOpen(true);
    }
  }, translate('SFxAccountSettingsAddSubscriptionsButtonText')), isOpen && /*#__PURE__*/React.createElement(VoucherModal, {
    translate: translate,
    isOpen: isOpen,
    setIsOpen: setIsOpen,
    onToggle: onToggle,
    refreshCallback: refreshCallback
  }));
};

export default RedeemVoucher;